import api, {
  multipartApi,
  invoiceApi,
  getLastHeaderVersion,
  formDataApi,
  handleUnauthorized,
} from "./axios";
import axios from "axios";

// Re-export getLastHeaderVersion for debugging
export { getLastHeaderVersion };

// login
export const adminLogin = (data) => api("admin/login", "POST", data);
export const producerLogin = (data) => api("producer/login", "POST", data);
export const agentLogin = (data) => api("sales_agent/login", "POST", data);
export const login = (data) => api("login", "POST", data);
export const logout = (data) => api("admin/logout", "POST", data);
export const resetUserPassword = (data) => api("reset-password", "POST", data);

// Recommendations
export const notificationRecommendation = (data) =>
  api(`recommendation/notifications`, "POST", data);
export const wspRecommendation = (data) =>
  api(`recommendation/whatsapp`, "POST", data);
export const callsRecommendation = (data) =>
  api(`recommendation/calls`, "POST", data);
export const inPersonRecommendation = (data) =>
  api(`recommendation/inperson`, "POST", data);

// Feedbacks
export const getFeedbacks = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_feedbacks?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const deleteFeedbacks = (id) =>
  api(`get_feedbacks_by_id/${id}`, "DELETE");
export const updateFeedbacks = (id, data) =>
  api(`update_feedbacks/${id}`, "PATCH", data);

// Permissions
export const fetchPermissions = (data) => api(`get_permissions`, "POST", data);
export const savePermissions = (data) =>
  api(`change_permissions`, "POST", data);

// Sales FollowUps
export const getSalesFollowUps = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_followups?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createSalesFollowUps = (data) =>
  api(`add_sales_followups`, "POST", data);
export const createWSPFollowUps = (data) =>
  api(`add_whatsapp_followups`, "POST", data);
export const updateSalesFollowUps = (data, id) =>
  api(`update_sales_followups/${id}`, "PATCH", data);
export const deleteSalesFollowUps = (id) =>
  api(`delete_sales_followups/${id}`, "DELETE");

// Sales Users
export const getSalesUsers = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_users?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createSalesUsers = (data) => api(`add_sales_users`, "POST", data);
export const updateSalesUsers = (data, id) =>
  api(`update_sales_users/${id}`, "PATCH", data);
export const deleteSalesUsers = (id) =>
  api(`delete_sales_users/${id}`, "DELETE");
export const getSalesUsersByAgentId = (
  id,
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_users_by_agent_id/${id}?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );

// Sales Visit
export const getSalesVisits = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_visits?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const getSalesVisitsByUserId = (
  id,
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_visits_by_user/${id}?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const getSalesVisitDetailById = (id) =>
  api(`get_sales_visits_by_id/${id}`, "GET");

// Region apis
export const fetchRegion = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_region?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const addRegion = (data) => api(`add_region`, "POST", data);
export const updateRegion = (data, id) =>
  api(`update_region/${id}`, "POST", data);
export const getRegionById = (id) => api(`get_region/${id}`, "GET");
export const getOfferByRegionId = (id) =>
  api(`get_offer_discount_by_offer_id/${id}`, "GET");
export const deleteRegionById = (id) => api(`delete_region/${id}`, "DELETE");

// Emails History
export const getEmailsHistory = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_emails_history?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createEmailsHistory = (data) =>
  api(`add_emails_history`, "POST", data);
export const updateEmailsHistory = (data, id) =>
  api(`update_emails_history/${id}`, "PATCH", data);
export const deleteEmailsHistory = (id) =>
  api(`delete_emails_history/${id}`, "DELETE");

// Emails History
export const getEmailsCcBcc = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_emails_cc_bcc?size=${size}&page=${page}&email=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createEmailsCcBcc = (data) =>
  api(`add_emails_cc_bcc`, "POST", data);
export const updateEmailsCcBcc = (data, id) =>
  api(`update_emails_cc_bcc/${id}`, "PATCH", data);
export const deleteEmailsCcBcc = (id) =>
  api(`delete_emails_cc_bcc/${id}`, "DELETE");

// Templates
export const getTemplates = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_content_templates?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createTemplates = (data) =>
  api(`add_content_templates`, "POST", data);
export const updateTemplates = (data, id) =>
  api(`update_content_templates/${id}`, "PATCH", data);
export const deleteTemplates = (id) =>
  api(`delete_content_templates/${id}`, "DELETE");
export const getTemplateTypes = (
  size = 10000,
  page = 0,
  name = "",
  sortBy = "type:asc"
) =>
  api(
    `get_template_type?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );

// Banners
export const getBanners = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_banners?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createBanners = (data) => api(`add_banners`, "POST", data);
export const updateBanners = (data, id) =>
  multipartApi(`update_banners/${id}`, "PATCH", data);
export const updateBannersDetail = (data, id) =>
  api(`update_banners_detail/${id}`, "PATCH", data);
export const deleteBanners = (id) => api(`delete_banners/${id}`, "DELETE");

// Banners
export const publicImages = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `marketing/images?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createpublicImages = (data) =>
  api(`upload_marketing_image`, "POST", data);

// RouteDeliveryLimit
export const getRouteDeliveryLimit = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_route_delivery_limits?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createRouteDeliveryLimit = (data) =>
  api(`add_route_delivery_limits`, "POST", data);
export const updateRouteDeliveryLimit = (data) =>
  api(`update_route_delivery_limits_by_name`, "PATCH", data);
export const deleteRouteDeliveryLimit = (id) =>
  api(`delete_route_delivery_limits_by_slug/${id}`, "DELETE");

// Store Category
export const storeCategories = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_store_category?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createStoreCategory = (data) =>
  api(`add_store_category`, "POST", data);
export const updateStoreCategory = (data, id) =>
  api(`update_store_category/${id}`, "PATCH", data);
export const deleteStoreCategory = (id) =>
  api(`delete_store_category/${id}`, "DELETE");

// deliveryClaims
export const deliveryClaims = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_delivery_claims?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createDeliveryClaims = (data) =>
  api(`add_delivery_claims`, "POST", data);
export const updateDeliveryClaims = (data, id) =>
  api(`update_delivery_claims/${id}`, "PATCH", data);
export const deleteDeliveryClaims = (id) =>
  api(`delete_delivery_claims/${id}`, "DELETE");

// deliveryissue
export const deliveryIssues = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_delivery_issues?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createDelivryIssues = (data) =>
  api(`add_delivery_issues`, "POST", data);
export const updateDelivryIssues = (data, id) =>
  api(`update_delivery_issues/${id}`, "PATCH", data);
export const deleteDeliveryIssues = (id) =>
  api(`delete_delivery_issues/${id}`, "DELETE");

// Delivery Image Category
export const getDeliveryImageCategories = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_delivery_image_categories?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createDeliveryImageCategories = (data) =>
  api(`add_delivery_image_categories`, "POST", data);
export const updateDeliveryImageCategories = (data, id) =>
  api(`update_delivery_image_categories/${id}`, "PATCH", data);
export const deleteDeliveryImageCategories = (id) =>
  api(`delete_delivery_image_categories/${id}`, "DELETE");

// Product Categories (E-commerce)
export const getProductCategories = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `product_categories?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createProductCategory = (data) =>
  multipartApi(`product_categories`, "POST", data);
export const updateProductCategory = (id, data) =>
  multipartApi(`product_categories/${id}`, "PATCH", data);
export const getProductCategoryById = (id) =>
  api(`product_categories/${id}`, "GET");
export const deleteProductCategory = (id) =>
  api(`product_categories/${id}`, "DELETE");

// Reorder Product Categories
export const moveProductCategory = (id, data) =>
  api(`product_categories/${id}/move`, "PATCH", data);

// Product Subcategories (E-commerce)
export const getProductSubcategories = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `product_subcategories?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const getActiveSubcategoriesByCategory = (category_id, size = 1000) =>
  api(`product_subcategories/by_category/${category_id}?size=${size}`, "GET");
export const createProductSubcategory = (data) =>
  multipartApi(`product_subcategories`, "POST", data);
export const updateProductSubcategory = (id, data) =>
  multipartApi(`product_subcategories/${id}`, "PATCH", data);
export const getProductSubcategoryById = (id) =>
  api(`product_subcategories/${id}`, "GET");
export const deleteProductSubcategory = (id) =>
  api(`product_subcategories/${id}`, "DELETE");

// Reorder Product Subcategories
// parentId is required by backend to scope the movement within a category
export const moveProductSubcategory = (parentId, id, data) =>
  api(`product_subcategories/${parentId}/${id}/move`, "PATCH", data);

// Delivery Image Category
export const getPickingImageCategories = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "row_number:asc"
) =>
  api(
    `get_delivery_picking_image_categories?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createPickingImageCategories = (data) =>
  api(`add_delivery_picking_image_categories`, "POST", data);
export const updatePickingImageCategories = (data, id) =>
  api(`update_delivery_picking_image_categories/${id}`, "PATCH", data);
export const getPickingselectedImageCategories = (queryString) =>
  api(
    `get_delivery_picking_selected_image_categories?size=${1000}&${queryString}`,
    "GET"
  );

// Return Product Category
export const getReturnProductCategory = (
  size = 1000,
  page = 0,
  name = "",
  sortBy = "row_number:asc"
) =>
  api(
    `return_reasons?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createReturnProductCategory = (data) =>
  api(`return_reasons`, "POST", data);
export const updateReturnProductCategory = (data, id) =>
  api(`return_reasons/${id}`, "PUT", data);
export const deleteReturnProductCategory = (data, id) =>
  api(`return_reasons/${id}`, "DELETE", data);

// Sales Image Category
export const getImageCategories = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_image_categories?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createImageCategories = (data) =>
  api(`add_image_categories`, "POST", data);
export const updateImageCategories = (data, id) =>
  api(`update_image_categories/${id}`, "PATCH", data);
export const deleteImageCategories = (data, id) =>
  api(`delete_image_categories/${id}`, "DELETE", data);

// Process Dropped
export const getProcessDropped = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_process_dropped?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createProcessDropped = (data) =>
  api(`add_process_dropped`, "POST", data);
export const updateProcessDropped = (data, id) =>
  api(`update_process_dropped/${id}`, "PATCH", data);
export const deleteProcessDropped = (data, id) =>
  api(`delete_process_dropped/${id}`, "DELETE", data);

// Sales Achievements
export const getSalesAchievements = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_achievements?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createSalesAchievements = (data) =>
  api(`add_sales_achievements`, "POST", data);
export const updateSalesAchievements = (data, id) =>
  api(`update_sales_achievements/${id}`, "PATCH", data);
export const deleteSalesAchievements = (data, id) =>
  api(`delete_sales_achievements/${id}`, "DELETE", data);

// Sales Arguments
export const getSalesArguments = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_arguments?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createSalesArguments = (data) =>
  api(`add_sales_arguments`, "POST", data);
export const updateSalesArguments = (data, id) =>
  api(`update_sales_arguments/${id}`, "PATCH", data);
export const deleteSalesArguments = (data, id) =>
  api(`delete_sales_arguments/${id}`, "DELETE", data);

// Sales Products
export const getSalesProducts = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_product?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createSalesProducts = (data) =>
  api(`add_sales_product`, "POST", data);
export const updateSalesProducts = (data, id) =>
  api(`update_sales_product/${id}`, "PATCH", data);
export const deleteSalesProducts = (id) =>
  api(`delete_sales_product/${id}`, "DELETE");

// Sales Agents
export const getSalesAgents = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_sales_agent?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createSalesAgents = (data) => api(`add_sales_agent`, "POST", data);
export const updateSalesAgents = (data, id) =>
  api(`update_sales_agent/${id}`, "PATCH", data);
export const deleteSalesAgents = (id) =>
  api(`delete_sales_agent/${id}`, "DELETE");

// Deliveries Agents
export const getDeliveryAgents = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_delivery_agent?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createDeliveryAgents = (data) =>
  api(`add_delivery_agent`, "POST", data);
export const updateDeliveryAgents = (data, id) =>
  api(`update_delivery_agent/${id}`, "PATCH", data);
export const deleteDeliveryAgents = (id) =>
  api(`delete_delivery_agent/${id}`, "DELETE");
export const getAgentDetailByOrder = (id) =>
  api(`get_delivery_agent_by_order/${id}`, "GET");

// Delivery Route Approval Config
export const getDeliveryRouteApprovalConfigs = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.delivery_agent_id)
    queryParams.append("delivery_agent_id", params.delivery_agent_id);
  if (params.date) queryParams.append("date", params.date);
  if (params.delivery_date_from)
    queryParams.append("delivery_date_from", params.delivery_date_from);
  if (params.delivery_date_to)
    queryParams.append("delivery_date_to", params.delivery_date_to);
  const query = queryParams.toString();
  return api(
    `delivery_route_approval_config${query ? `?${query}` : ""}`,
    "GET"
  );
};
export const saveDeliveryRouteApprovalConfig = (data) =>
  api("delivery_route_approval_config", "POST", data);
export const deleteDeliveryRouteApprovalConfig = (id) =>
  api(`delivery_route_approval_config/${id}`, "DELETE");

// Location apis
export const fetchLocation = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_location?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const addLocation = (data) => api(`add_location`, "POST", data);
export const updateLocation = (data, id) =>
  api(`update_location/${id}`, "POST", data);
export const getLocationById = (id) => api(`get_location_by_id/${id}`, "GET");
export const getLocationByRegion = (id, size, page, name) =>
  api(
    `get_location_by_region/${id}?name=${name}&size=${size}&page=${page}`,
    "GET"
  );
export const deleteLocationById = (id) =>
  api(`delete_location/${id}`, "DELETE");
export const getLocationByCity = (id) =>
  api(`get_location_by_city/${id}`, "GET");

// Category apis
export const fetchCategory = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_category?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const addCategory = (data) => api(`add_category`, "POST", data);
export const updateCategory = (data, id) =>
  api(`update_category/${id}`, "PATCH", data);
export const getCategoryById = (id) => api(`get_category_by_id/${id}`, "GET");
export const deleteCategoryById = (id) =>
  api(`delete_category/${id}`, "DELETE");

// Payment methods apis
export const fetchPayment = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_payment?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const addPayment = (data) => api(`add_payment`, "POST", data);
export const updatePayment = (data, id) =>
  api(`update_payment/${id}`, "PATCH", data);
export const getPaymentById = (id) => api(`get_payment_by_id/${id}`, "GET");
export const deletePaymentById = (id) => api(`delete_payment/${id}`, "DELETE");

// Producer Payment methods apis
export const fetchProducerPayment = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_producer_payment?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const addProducerPayment = (data) =>
  api(`add_producer_payment`, "POST", data);
export const updateProducerPayment = (data, id) =>
  api(`update_producer_payment/${id}`, "PATCH", data);
export const getProducerPaymentById = (id) =>
  api(`get_producer_payment_by_id/${id}`, "GET");
export const getProducerPaymentByProducer = (id) =>
  api(`get_producer_payment_by_producer/${id}`, "GET");
export const deleteProducerPaymentByProducer = (producerId, paymentId) =>
  api(
    `delete_producer_payment_by_producer/${producerId}/${paymentId}`,
    "DELETE"
  );
export const deleteProducerPaymentById = (id) =>
  api(`delete_producer_payment/${id}`, "DELETE");

// Product main apis
// filters: { warehouse_id, pos_active, is_active } (all optional)
export const fetchProductMain = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  producerId = 0,
  regionId = 0,
  filters = {}
) => {
  let url = `get_product_main?size=${size}&page=${page}&name=${encodeURIComponent(name)}&orderBy=${sortBy}&producer_id=${producerId}&region_id=${regionId}`;
  const { warehouse_id, pos_active, is_active } = filters;
  if (warehouse_id != null && warehouse_id !== "" && Number(warehouse_id) > 0)
    url += `&warehouse_id=${warehouse_id}`;
  if (pos_active === true || pos_active === 1) url += "&pos_active=1";
  else if (pos_active === false || pos_active === 0) url += "&pos_active=0";
  if (is_active === true || is_active === 1) url += "&is_active=1";
  else if (is_active === false || is_active === 0) url += "&is_active=0";
  return api(url, "GET");
};
export const fetchProductMainByRegion = (
  size = 10,
  page = 0,
  name = "",
  id = ""
) =>
  api(
    `get_product_main_by_region?size=${size}&page=${page}&name=${name}&region_id=${id}&orderBy=createdAt:asc`,
    "GET"
  );
export const addProductMain = (data) => api(`add_product_main`, "POST", data);
export const bulkAddProductMain = (data) =>
  api(`bulk_add_product_main`, "POST", data);
export const updateProductMain = (data, id) =>
  api(`update_product_main/${id}`, "PATCH", data);
export const getProductMainById = (id) =>
  api(`get_product_main_by_id/${id}`, "GET");
export const deleteProductMainById = (id) =>
  api(`delete_product_main/${id}`, "DELETE");
export const toggleProductMainActive = (id, isActive) =>
  api(`product_main/${id}/toggle_active`, "PATCH", { is_active: isActive });
export const toggleProductMainStock = (id, isInStock) =>
  api(`product_main/${id}/toggle_stock`, "PATCH", { is_in_stock: isInStock });
export const toggleProductMainPosActive = (id, isPosActive) =>
  api(`product_main/${id}/toggle_pos_active`, "PATCH", { is_pos_active: isPosActive });

// Producers apis
export const fetchProducer = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "order:desc"
) =>
  api(
    `get_producer?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const updateProducerOrder = (data) =>
  api(`update_producer_order`, "POST", data);
export const addProducer = (data) => api(`add_producer`, "POST", data);
export const updateProducer = (data, id) =>
  api(`update_producer/${id}`, "POST", data);
export const getProducerById = (id) => api(`get_producer/${id}`, "GET");
export const toggleProducerActive = (id) =>
  api(`toggle_producer_active/${id}`, "PATCH");
export const toggleProducerPosActive = (id) =>
  api(`toggle_producer_pos_active/${id}`, "PATCH");
export const deleteProducerById = (id) =>
  api(`delete_producer/${id}`, "DELETE");

// Agents apis
export const fetchAgent = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_agent?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const addAgent = (data) => api(`add_agent`, "POST", data);
export const updateAgent = (data, id) =>
  api(`update_agent/${id}`, "PATCH", data);
export const getAgentById = (id) => api(`get_agent_by_id/${id}`, "GET");
export const deleteAgentById = (id) => api(`delete_agent/${id}`, "DELETE");

// Users of agent
export const get_users_of_agent = (
  id,
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_users_of_agent/${id}?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const deleteUserOfAgent = (id) =>
  api(`delete_user_of_agent/${id}`, "DELETE");
export const addUserOfAgent = (data) => api(`assign_users`, "POST", data);

// POS Product apis
export const fetchPosProductMaster = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  producerId = 0
) =>
  api(
    `get_pos_products?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}&producer_id=${producerId}`,
    "GET"
  );
export const addPosProductMaster = (data) =>
  api(`add_pos_products`, "POST", data);
export const updatePosProductMaster = (data, id) =>
  api(`update_pos_products/${id}`, "PATCH", data);
export const getPosProductMasterById = (id) =>
  api(`get_pos_products_by_id/${id}`, "GET");
export const deletePosProductMasterById = (id) =>
  api(`delete_pos_products/${id}`, "DELETE");
export const exportPosProducts = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const axiosInstance = axios.create();

  // Add interceptor for 401 handling (shared logic — guards against the
  // infinite reload loop and clears the real session keys).
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance.get(`${baseURL}/export_pos_products`, {
    headers: {
      "x-access-token": `${localStorage.getItem("accessToken")}`,
    },
    responseType: "blob",
  });
};
export const importPosProducts = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return multipartApi(`import_pos_products`, "POST", formData);
};

// POS Admin APIs
export const getPosInvoices = (
  page = 1,
  size = 10,
  userId = "",
  startDate = "",
  endDate = ""
) => {
  let url = `pos/admin/invoices?page=${page}&size=${size}`;
  if (userId) url += `&user_id=${userId}`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  return api(url, "GET");
};

export const getPosProductsByQuantity = (
  page = 1,
  size = 10,
  categoryId = "",
  userId = ""
) => {
  let url = `pos/admin/products/by_quantity?page=${page}&size=${size}`;
  if (categoryId) url += `&category_id=${categoryId}`;
  if (userId) url += `&user_id=${userId}`;
  return api(url, "GET");
};

// Product master apis
// filters: { is_active, pos_active, category_id, subcategory_id, has_image, has_not_image, no_subcategory } (all optional)
export const fetchProductMaster = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  producerId = 0,
  filters = {}
) => {
  let url = `get_product_master?size=${size}&page=${page}&name=${encodeURIComponent(name)}&orderBy=${sortBy}&producer_id=${producerId}`;
  const { is_active, pos_active, category_id, subcategory_id, has_image, has_not_image, no_subcategory } = filters;
  if (is_active === 1 || is_active === true) url += "&is_active=1";
  else if (is_active === 0 || is_active === false) url += "&is_active=0";
  if (pos_active === 1 || pos_active === true) url += "&pos_active=1";
  else if (pos_active === 0 || pos_active === false) url += "&pos_active=0";
  if (category_id != null && category_id !== "" && Number(category_id) > 0)
    url += `&category_id=${category_id}`;
  if (subcategory_id != null && subcategory_id !== "" && Number(subcategory_id) > 0)
    url += `&subcategory_id=${subcategory_id}`;
  if (has_image === true || has_image === 1) url += "&has_image=1";
  if (has_not_image === true || has_not_image === 1) url += "&has_not_image=1";
  if (no_subcategory === true || no_subcategory === 1) url += "&no_subcategory=1";
  return api(url, "GET");
};
export const addProductMaster = (data) =>
  api(`add_product_master`, "POST", data);
export const updateProductMaster = (data, id) =>
  api(`update_product_master/${id}`, "PATCH", data);
export const getProductMasterById = (id) =>
  api(`get_product_master_by_id/${id}`, "GET");
export const deleteProductMasterById = (id) =>
  api(`delete_product_master/${id}`, "DELETE");
export const toggleProductMasterActive = (id, isActive) =>
  api(`product_master/${id}/toggle_active`, "PATCH", { is_active: isActive });
export const toggleProductMasterPosActive = (id, isPosActive) =>
  api(`product_master/${id}/toggle_pos_active`, "PATCH", { is_pos_active: isPosActive });

// Product Import / Export apis (admin only, base path: product_import)
export const productImportExportSample = (format = "xlsx") => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  return axios.get(`${baseURL}/product_import/export_sample?format=${format}`, {
    headers: { "x-access-token": `${localStorage.getItem("accessToken")}` },
    responseType: "blob",
  });
};

export const productImportExportProducts = (params = {}) => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const q = new URLSearchParams();
  q.set("format", params.format || "xlsx");
  if (params.columns) q.set("columns", params.columns);
  if (params.region_id != null) q.set("region_id", params.region_id);
  if (params.producer_id != null) q.set("producer_id", params.producer_id);
  if (params.product_subcategory_id != null) q.set("product_subcategory_id", params.product_subcategory_id);
  if (params.product_category_id != null) q.set("product_category_id", params.product_category_id);
  if (params.is_active !== undefined && params.is_active !== "") q.set("is_active", params.is_active);
  if (params.is_in_stock !== undefined && params.is_in_stock !== "") q.set("is_in_stock", params.is_in_stock);
  return axios.get(`${baseURL}/product_import/export_products?${q.toString()}`, {
    headers: { "x-access-token": `${localStorage.getItem("accessToken")}` },
    responseType: "blob",
  });
};

export const productImportImport = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return multipartApi("product_import/import", "POST", formData);
};

export const productImportDryRun = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return multipartApi("product_import/import_dry_run", "POST", formData);
};

export const productImportListPending = (
  page = 1,
  limit = 50,
  params = {}
) => {
  let url = `product_import/list_pending?page=${page}&limit=${Math.min(limit, 100)}`;
  if (params.import_batch_id) url += `&import_batch_id=${encodeURIComponent(params.import_batch_id)}`;
  if (params.status) url += `&status=${encodeURIComponent(params.status)}`;
  if (params.include_deleted === true) url += "&include_deleted=true";
  return api(url, "GET");
};

export const productImportUpdateStaging = (id, data) =>
  api(`product_import/update/${id}`, "PATCH", data);

export const productImportApproveDryRun = (id, data) =>
  api(`product_import/approve_dry_run/${id}`, "POST", data);

export const productImportApprove = (id, data) =>
  api(`product_import/approve/${id}`, "POST", data);

export const productImportReject = (id, data = {}) =>
  api(`product_import/reject/${id}`, "POST", data);

export const productImportSoftDelete = (id) =>
  api(`product_import/soft_delete/${id}`, "PATCH");

export const productImportRestore = (id) =>
  api(`product_import/restore/${id}`, "PATCH");

// Promoted Product apis
export const fetchPromotedProduct = (
  size = 10,
  page = 0,
  search = "",
  sortBy = "id:desc"
) =>
  api(
    `promoted_products?size=${size}&page=${page}&search=${search}&orderBy=${sortBy}`,
    "GET"
  );
export const addPromotedProduct = (data) =>
  api(`promoted_products`, "POST", data);
export const updatePromotedProduct = (id, data) =>
  api(`promoted_products/${id}`, "PATCH", data);
export const getPromotedProductById = (id) =>
  api(`promoted_products/${id}`, "GET");
export const deletePromotedProductById = (id) =>
  api(`promoted_products/${id}`, "DELETE");

// Offer master apis
export const fetchOffer = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  producerId = 0
) =>
  api(
    `get_offer_description?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}&producer_id=${producerId}`,
    "GET"
  );
export const addOffer = (data) => api(`add_offer_description`, "POST", data);
export const updateOffer = (data, id) =>
  api(`update_offer_description/${id}`, "PATCH", data);
export const getOfferById = (id) =>
  api(`get_offer_description_by_id/${id}`, "GET");
export const deleteOfferById = (id) =>
  api(`delete_offer_description/${id}`, "DELETE");

// Offer discount apis
export const fetchOfferDiscount = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_offer_discount?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const addOfferDiscount = (data) =>
  api(`add_offer_discount`, "POST", data);
export const updateOfferDiscount = (data, id) =>
  api(`update_offer_discount/${id}`, "PATCH", data);
export const getOfferDiscountById = (id) =>
  api(`get_offer_discount_by_id/${id}`, "GET");
export const deleteOfferDiscountById = (id) =>
  api(`delete_offer_discount/${id}`, "DELETE");

// Coupon code apis
export const createCouponCode = (data) =>
  api(`create_coupon_code`, "POST", data);
export const generateBulkCoupons = (data) =>
  api(`generate_bulk_coupons`, "POST", data);
export const getCouponCodes = (
  page = 1,
  limit = 10,
  campaign_name = "",
  is_active = ""
) =>
  api(
    `get_coupon_codes?page=${page}&limit=${limit}&campaign_name=${campaign_name}&is_active=${is_active}`,
    "GET"
  );
export const getCouponAnalytics = (data) =>
  api(`get_coupon_analytics`, "POST", data);
export const deleteCouponCode = (id) =>
  api(`delete_coupon_code/${id}`, "DELETE");
export const updateCouponCode = (id, data) =>
  api(`update_coupon_code/${id}`, "PATCH", data);

// Routes apis
export const fetchRoutes = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  region = ""
) =>
  api(
    `get_route?size=${size}&page=${page}&route_master=${name}&orderBy=${sortBy}&region=${region}`,
    "GET"
  );
export const fetchRoutesGroupedByLocation = (name = "") =>
  api(`group_by_location?name=${name}`, "GET");
export const addRoutes = (data) => api(`add_route`, "POST", data);
export const updateRoutes = (data, id) =>
  api(`update_route/${id}`, "PATCH", data);
export const getRoutesById = (id) => api(`get_route_by_id/${id}`, "GET");
export const getRoutesByLocationIdAndDay = (id, day) =>
  api(`get_route_by_location_id/${id}/${day}`, "GET");
export const getRoutesByLocationId = (id, day) =>
  api(`get_route_by_location_id/${id}`, "GET");
export const deleteRoutesById = (id) => api(`delete_route/${id}`, "DELETE");

// minimum order value apis
export const fetchLatestOrderValue = (size = 10, page = 0, name = "") =>
  api(`get_order_value`, "GET");
export const fetchOrderValue = (size = 10, page = 0, name = "") =>
  api(
    `get_order_value?size=${size}&page=${page}&name=${name}&orderBy=order_value:asc`,
    "GET"
  );
export const addOrderValue = (data) => api(`add_order_value`, "POST", data);
export const updateOrderValue = (data, id) =>
  api(`update_order_value/${id}`, "PATCH", data);
export const getOrderValueById = (id) =>
  api(`get_order_value_by_id/${id}`, "GET");
export const deleteOrderValueById = (id) =>
  api(`delete_order_value/${id}`, "DELETE");

// tax rate value apis
export const fetchTaxRate = (size = 10, page = 0, name = "") =>
  api(
    `get_latest_tax_rate?size=${size}&page=${page}&name=${name}&orderBy=tax_rate:asc`,
    "GET"
  );
export const addTaxRate = (data) => api(`add_tax_rate`, "POST", data);
export const updateTaxRate = (data, id) =>
  api(`update_tax_rate/${id}`, "PATCH", data);
export const getTaxRateById = (id) => api(`get_tax_rate_by_id/${id}`, "GET");
export const deleteTaxRateById = (id) => api(`delete_tax_rate/${id}`, "DELETE");

// order apis
export const fetchOrders = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  producerId = 0,
  deliveryDate = "",
  showUpfrontPayments = false,
  productId = 0,
  regionIds = "",
  locationIds = "",
  orderStatus = "",
  deliveryAgentId = "",
  hasInvoice = ""
) => {
  let url = `get_orders_master?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}&producer_id=${producerId}&deliveryDate=${deliveryDate}&includeLastOrderStatus=${showUpfrontPayments}`;

  if (productId && productId !== 0) {
    url += `&product_master_ids=${productId}`;
  }

  if (regionIds && regionIds !== "") {
    url += `&region_ids=${regionIds}`;
  }

  if (locationIds && locationIds !== "") {
    url += `&location_ids=${locationIds}`;
  }

  if (orderStatus && orderStatus !== "") {
    url += `&order_status=${orderStatus}`;
  }

  if (deliveryAgentId && deliveryAgentId !== "") {
    url += `&delivery_agent_id=${deliveryAgentId}`;
  }

  if (hasInvoice && hasInvoice !== "") {
    url += `&has_invoice=${hasInvoice}`;
  }

  return api(url, "GET");
};
// Returns ONLY the order ids matching the given filters (no pagination), so the
// admin can "select all across pages" without walking every page. Same filter
// contract as fetchOrders.
export const fetchOrderIds = (
  name = "",
  sortBy = "id:desc",
  producerId = 0,
  deliveryDate = "",
  productId = 0,
  regionIds = "",
  locationIds = "",
  orderStatus = "",
  deliveryAgentId = "",
  hasInvoice = ""
) => {
  let url = `get_orders_master_ids?name=${name}&orderBy=${sortBy}&producer_id=${producerId}&deliveryDate=${deliveryDate}`;

  if (productId && productId !== 0) {
    url += `&product_master_ids=${productId}`;
  }
  if (regionIds && regionIds !== "") {
    url += `&region_ids=${regionIds}`;
  }
  if (locationIds && locationIds !== "") {
    url += `&location_ids=${locationIds}`;
  }
  if (orderStatus && orderStatus !== "") {
    url += `&order_status=${orderStatus}`;
  }
  if (deliveryAgentId && deliveryAgentId !== "") {
    url += `&delivery_agent_id=${deliveryAgentId}`;
  }
  if (hasInvoice && hasInvoice !== "") {
    url += `&has_invoice=${hasInvoice}`;
  }

  return api(url, "GET");
};
export const fetchTodayOrders = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  producerId = 0
) =>
  api(
    `get_orders_master?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}&producer_id=${producerId}&today=yes`,
    "GET"
  );
export const addOrders = (data) => api(`add_orders_master`, "POST", data);
export const updateOrders = (data, id) =>
  api(`update_orders_master/${id}`, "PATCH", data);
export const updateOrderUserStatus = (data) =>
  api(`update_order_user_status`, "POST", data);
export const getOrdersById = (id) =>
  api(`get_orders_master_by_id/${id}`, "GET");
export const countTotalOrders = (producerId) =>
  api(`get_total_orders_count?producer_id=${producerId}`, "GET");
export const countPendingOrders = (producerId) =>
  api(`get_pending_orders_count?producer_id=${producerId}`, "GET");
export const countDeliveredOrders = (producerId) =>
  api(`get_completed_orders_count?producer_id=${producerId}`, "GET");
export const deleteOrdersById = (id) =>
  api(`delete_orders_master/${id}`, "DELETE");
export const applyOrderRevertAction = (data) =>
  api(`apply_order_revert_action`, "POST", data);

// order detail apis
export const getOrderDetailById = (id) =>
  api(`get_order_details_by_id/${id}`, "GET");
export const getOrderDetailByOrderId = (id) =>
  api(`get_order_details_by_order_id/${id}?size=${10000}`, "GET");
export const getOrderFeedbackByOrderId = (id) =>
  api(`get_delivery_feedbacks_by_order/${id}`, "GET");
export const addOrderOfAgent = (data) => api(`assign_orders`, "POST", data);
export const uploadDeliveryImage = (data) =>
  multipartApi(`upload_delivery_image`, "POST", data);
export const addOcrInvoicingDetails = (data) =>
  api(`add_multiple_ocr_invoicing_details`, "POST", data);
export const updateOrderQuantity = (data) =>
  api(`edit_order_quantity`, "POST", data);
export const addProductInOrder = (data) =>
  api(`add_products_to_order`, "POST", data);
export const changeProductInOrder = (data) =>
  api(`change_order_product`, "POST", data);
// unified order edit (add/update/remove products + meta changes)
export const unifiedOrderEdit = (data) =>
  api(`unified_order_edit`, "POST", data);

// order status`
export const getOrderStatusTypes = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_order_status_types?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );

// users apis
export const fetchUsers = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  sii = "" // "1" = has SII company, "0" = none, "" = all
) =>
  api(
    `fetch_users?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}${sii !== "" ? `&sii=${sii}` : ""}`,
    "GET"
  );
export const fetchAdmins = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `fetch_admins?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const getUsersById = (id) => api(`fetch_user_by_id/${id}`, "GET");
export const updateUsersById = (data, id) =>
  api(`update_user/${id}`, "POST", data);
export const toggleUserPosActive = (userId) =>
  api(`admin/users/${userId}/toggle_pos_active`, "PATCH");
export const forgetPassword = (data, id) =>
  api(`forget-password`, "POST", data);
export const createUser = (data) => api(`add_user`, "POST", data);
export const createAdmin = (data) => api(`add_admin`, "POST", data);
export const deleteUsersById = (id) => api(`delete_user_by_id/${id}`, "DELETE");
export const countUsers = (producerId) =>
  api(`get_users_count?producer_id=${producerId}`, "GET");
export const searchUsers = (name = "") =>
  api(`fetch_all_users?name=${name}&size=5`, "GET");
export const searchUsersAndConsumers = (name = "") =>
  api(`fetch_all_users_and_consumers?name=${name}&size=5`, "GET");
export const linkSalesUser = (id, data) =>
  api(`link_sales_user/${id}`, "POST", data);
export const assignSalesAgentToUser = (data, id) =>
  api(`assign_sales_agent_user/${id}`, "POST", data);

// whatsapp message
export const getWspChats = () => api(`whatsapp/chats`, "POST");
export const getWspChatMsg = (data) => api(`whatsapp/chat`, "POST", data);
export const addNewWspMessages = (data) => api(`whatsapp/send`, "POST", data);
export const sendWhatsappByContent = (data) =>
  api(`whatsapp/send_whatsapp`, "POST", data);
export const markWspMsgAsRead = (data) =>
  api(`whatsapp/mark_as_read`, "POST", data);
export const previewTwilioWhatsappImport = (data) =>
  formDataApi(`whatsapp/import_twilio_export/preview`, "POST", data);
export const importTwilioWhatsappExport = (data) =>
  formDataApi(`whatsapp/import_twilio_export`, "POST", data);

// chat message
export const fetchChats = () => api(`chat`, "GET");
export const createChat = (data) => api(`chat`, "POST", data);
export const fetchGroupMessages = (id) => api(`message/${id}`, "GET");
export const addNewMessages = (data) => api(`message`, "POST", data);
export const sendFileToUser = (data) =>
  multipartApi(`message/upload`, "POST", data);

// customer issues apis
export const fetchCustomerIssues = (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      queryParams.append(key, params[key]);
    }
  });
  return api(`customer_issues?${queryParams.toString()}`, "GET");
};
export const fetchCustomerIssueById = (id) => api(`customer_issues/${id}`, "GET");
export const createCustomerIssue = (data) => api(`customer_issues`, "POST", data);
export const updateCustomerIssue = (id, data) => api(`customer_issues/${id}`, "PATCH", data);
export const assignCustomerIssue = (id, data) => api(`customer_issues/${id}/assign`, "POST", data);
export const resolveCustomerIssue = (id, data) => api(`customer_issues/${id}/resolve`, "POST", data);
export const closeCustomerIssue = (id, data) => api(`customer_issues/${id}/close`, "POST", data);
export const reopenCustomerIssue = (id, data) => api(`customer_issues/${id}/reopen`, "POST", data);
export const addIssueComment = (id, data) => api(`customer_issues/${id}/comments`, "POST", data);
export const fetchIssueStatistics = () => api(`customer_issues/statistics`, "GET");
export const fetchAssignableUsers = (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      queryParams.append(key, params[key]);
    }
  });
  return api(`customer_issues/assignable_users?${queryParams.toString()}`, "GET");
};
export const sendSOSAlert = (data) => api(`delivery_sos_alert`, "POST", data);

// notifications apis
export const addSalesNotification = (data) =>
  api(`send_sales_notifications`, "POST", data);
export const addAllNotification = (data) => api(`sendToAll`, "POST", data);
export const fetchNotifications = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  type = "",
  category = "",
  startDate = "",
  endDate = ""
) => {
  let url = `fetch_notifications?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`;

  if (type) {
    url += `&type=${type}`;
  }
  if (category) {
    url += `&category=${category}`;
  }
  if (startDate) {
    url += `&start_date=${startDate}`;
  }
  if (endDate) {
    url += `&end_date=${endDate}`;
  }

  return api(url, "GET");
};
export const fetchNotificationsUsers = (
  id,
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `fetch_notifications_details/${id}?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const getNotificationTypes = () => api(`get_notification_types`, "GET");
export const getNotificationById = (id) =>
  api(`fetch_notification_by_id/${id}`, "GET");
export const deletNotificationById = (id) =>
  api(`delete_notification_by_id/${id}`, "DELETE");

// notifications templates
export const fetchNotificationTemplates = (size = 10, page = 0, name = "") =>
  api(
    `get_templates?size=${size}&page=${page}&name=${name}&orderBy=id:asc`,
    "GET"
  );
export const addNotificationTemplates = (data) =>
  api(`add_templates`, "POST", data);
export const updateNotificationTemplates = (data, id) =>
  api(`update_templates/${id}`, "PATCH", data);
export const getNotificationTemplatesById = (id) =>
  api(`get_templates/${id}`, "GET");
export const deleteNotificationTemplatesById = (id) =>
  api(`delete_templates/${id}`, "DELETE");

// report generation
export const generateReport = (data) => api(`generate_report`, "POST", data);
export const generateInvoicing = (data) =>
  api(`generate_invoicing`, "POST", data);
export const generateDeliveryReport = (data) =>
  api(`generate_delivery_report`, "POST", data);
export const generateSummaryReport = (data) =>
  api(`generate_summary`, "POST", data);
export const generateOrderDetails = (data) =>
  api(`generate_orders_detail`, "POST", data);
export const generateSalesChart = (data) =>
  api(`generate_sales_chart`, "POST", data);
export const generateSalesChartAgent = (data) =>
  api(`generate_sales_chart_agent`, "POST", data);
export const generateUserPerRouteChart = (data) =>
  api(`generate_users_per_route`, "POST", data);

// Sales Evolution APIs
export const getSalesEvolution = (params) => {
  // Build query string manually to avoid encoding commas in product_main_ids
  const queryParts = [];
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      queryParts.push(`${key}=${params[key]}`);
    }
  });
  const queryString = queryParts.join('&');
  return api(`sales_evolution?${queryString}`, "GET");
};

export const getSalesEvolutionComparison = (params) => {
  // Build query string manually to avoid encoding commas in product_main_ids
  const queryParts = [];
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      queryParts.push(`${key}=${params[key]}`);
    }
  });
  const queryString = queryParts.join('&');
  return api(`sales_evolution_comparison?${queryString}`, "GET");
};

const buildQueryString = (params) => {
  const queryParts = [];
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      queryParts.push(`${key}=${params[key]}`);
    }
  });
  return queryParts.join("&");
};

export const getProducerChartData = (params) =>
  api(`producer_chart_data?${buildQueryString(params)}`, "GET");

export const getProducerChartMetrics = (params) =>
  api(`producer_chart_metrics?${buildQueryString(params)}`, "GET");

export const exportProducerWeeklyReportPdf = (params) =>
  api(`producer_weekly_report_pdf?${buildQueryString(params)}`, "GET");

export const exportSalesEvolutionPDF = (params) => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const axiosInstance = axios.create();

  // Add interceptor for 401 handling (shared logic — guards against the
  // infinite reload loop and clears the real session keys).
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
      return Promise.reject(error);
    }
  );

  // Build query string manually to avoid encoding commas in product_main_ids
  const queryParts = [];
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      queryParts.push(`${key}=${params[key]}`);
    }
  });
  // Add export_format=pdf
  queryParts.push('export_format=pdf');
  const queryString = queryParts.join('&');

  return axiosInstance.get(`${baseURL}/sales_evolution?${queryString}`, {
    headers: {
      "x-access-token": `${localStorage.getItem("accessToken")}`,
    },
    responseType: "blob",
  });
};

export const weeklyReport = (data) => api(`weekly_sales`, "POST", data);
export const generateMarginReport = (
  start_date = "",
  end_date = "",
  producer_id = "",
  product_id = "",
  page = 1,
  size = 15
) => {
  const params = new URLSearchParams();
  if (start_date) params.set("start_date", start_date);
  if (end_date) params.set("end_date", end_date);
  if (producer_id) params.set("producer_id", producer_id);
  if (product_id) params.set("product_id", product_id);
  params.set("page", String(page));
  params.set("size", String(size));
  return api(`delivery_margin_report?${params.toString()}`, "GET");
};
export const fixMarginMismatches = ({
  start_date = "",
  end_date = "",
  order_id = "",
  product_id = "",
  movement_id = "",
  dry_run = false,
  min_difference_threshold = 1,
} = {}) => {
  const params = new URLSearchParams();
  if (start_date) params.set("start_date", start_date);
  if (end_date) params.set("end_date", end_date);
  if (order_id) params.set("order_id", String(order_id));
  if (product_id) params.set("product_id", String(product_id));
  if (movement_id) params.set("movement_id", String(movement_id));
  params.set("dry_run", String(dry_run));
  params.set("min_difference_threshold", String(min_difference_threshold));
  return api(`fix_margin_mismatches?${params.toString()}`, "POST");
};
export const generateEtaAccuracyReport = (data) =>
  api(`export_eta_accuracy_report`, "POST", data);

// Picking List v2.0 APIs
export const getPickingListStatus = (deliveryDate) =>
  api(`picking_list_status?delivery_date=${deliveryDate}`, "GET");
export const getPickingListHistory = (
  deliveryDate = "",
  page = 1,
  limit = 50
) => {
  let url = `picking_list_history?page=${page}&limit=${limit}`;
  if (deliveryDate) url += `&delivery_date=${deliveryDate}`;
  return api(url, "GET");
};

// billing invoice (DTE v2.0 - Type 33)
// Emission goes through the backend proxy (/admin/sii/proxy_emission) so every
// outcome — including transitorios — is recorded in invoice_document_history
// at emission time. The saas response passes through verbatim.
export const addInvoice = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "factura",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const deleteInvoice = (id) => invoiceApi(`api/factura/${id}`, "DELETE");
export const addInvoiceAddress = (data) => api(`add_invoice`, "POST", data);
export const deleteInvoiceAddress = (id) =>
  api(`delete_invoice_details/${id}`, "DELETE");
export const updateInvoiceInfo = (data) => {
  // update_invoice_info validates order_id/user_id as numbers. Modals opened
  // from the Documents page have no order context and were sending "" — coerce
  // numeric strings, drop empty/invalid values.
  const payload = { ...data };
  ["order_id", "user_id"].forEach((key) => {
    const value = Number(payload[key]);
    if (payload[key] === "" || payload[key] == null || Number.isNaN(value)) {
      delete payload[key];
    } else {
      payload[key] = value;
    }
  });
  return api("update_invoice_info", "POST", payload);
};
export const getDocumentsHistory = (id) =>
  api(`get_document_history?order_id=${id}&size=${1000}&page=${0}`);

// Credit Notes (DTE v2.0 - Type 61)
export const generateTotalCreditNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-credito/total",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generatePartialCreditNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-credito/parcial",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });

// Debit Notes (DTE v2.0 - Type 56)
export const generateProductDebitNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-debito/productos",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateAmountDebitNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-debito/monto",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });

// Guía de Despacho (DTE v2.0 - Type 52)
export const generateElectronicGuiaDespacho = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "guia-despacho/electronica",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateManualGuiaDespacho = (data) =>
  invoiceApi("guia-despacho/manual", "POST", data);

//WareHouse
export const addWareHouse = (data) => api(`add_warehouse`, "POST", data);
export const updateWareHouse = (data, id) =>
  api(`update_warehouse/${id}`, "PATCH", data);
export const getWareHouse = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_warehouse?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const getWareHouseById = (id) => api(`get_warehouse/${id}`, "GET");

// fidelity configuration
export const fidelityConfiguration = () => api(`fidelity_config`, "GET");
export const updateFidelityConfiguration = (data) =>
  api(`fidelity_config`, "PUT", data);

// referral configuration
export const referralConfiguration = () => api(`referral/config/active`, "GET");
export const updateReferralConfiguration = (data) =>
  api(`referral/config`, "POST", data);
export const referralAnalytics = () => api(`referral/admin/analytics`, "GET");
export const referralDetails = () => api(`referral/admin/details`, "GET");

// claimed discounts
export const claimedDiscounts = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `claimed_discounts?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );

// users not claimed discounts
export const usersNotClaimedDiscounts = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `users_not_claimed_discounts?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );

// potential claims
export const potentialClaims = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `potential_claims?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );

// delivery address
export const addAddress = (data) => api(`add_address`, "POST", data);
export const deleteAddress = (id) =>
  api(`delete_delivery_address/${id}`, "DELETE");

// sales report
export const getSalesReport = (
  salesNumber,
  averageSales,
  startDate,
  endDate,
  data
) =>
  api(
    `sales-report?salesNumber=${salesNumber}&averageSales=${averageSales}&startDate=${startDate}&endDate=${endDate}`,
    "POST",
    data
  );

export const generateCustomerOrderDate = (data) =>
  api(`generate_customer_order_date`, "POST", data);
export const generateCustomerOrderSalesDate = (data) =>
  api(`generate_customer_order_date_sales`, "POST", data);
export const generateCustomerDeliverOrderSalesDate = (data) =>
  api(`generate_customer_deliver_order_date_sales`, "POST", data);
export const generateProducerSalesReport = (data) =>
  api(`generate_sales_report_producer`, "POST", data);
export const generateDailyDeliveryReport = (data) =>
  api(`generate_daily_delivery_report`, "POST", data);
export const generateDeliveryReportPdf = (data) =>
  api(`generate_delivery_report_pdf`, "POST", data);
export const generateDeliveryOrderHistory = (data, size, queryParam) =>
  api(
    `get_delivered_orders_history?size=${size}&deliveryDate=${data}&${queryParam}`,
    "GET"
  );
export const generateCustomerDeliverOrderDate = (data) =>
  api(`generate_customer_deliver_order_date`, "POST", data);

// sales agents report
export const getSalesAgentsReport = (startDate, endDate, route_id = "") =>
  api(
    `get_sales_agent_report?startDate=${startDate}&endDate=${endDate}&route_id=${route_id}`,
    "GET"
  );

// delivery Dashboard
export const getDeliveryDashboard = (data) =>
  api(`get_my_routes_dashboard`, "POST", data);

// Optimize Delivery Route
export const optimizeDeliveryRoute = (data) =>
  api(`optimize_delivery_route`, "POST", data);

// Export Delivery Route (PDF or Excel)
export const exportDeliveryRoute = (data) =>
  api(`export_delivery_route`, "POST", data);

// Delivery Track - Get truck tracking data
export const getDeliveryTrack = (
  date = "",
  deliveryAgentId = "",
  page = 0,
  size = 10000000,
  orderBy = "created_at:asc"
) =>
  api(
    `get_delivery_track?date=${date}&deliveryAgentId=${deliveryAgentId}&page=${page}&size=${size}&orderBy=${orderBy}`,
    "GET"
  );

// Get Active Route Suggestion - Fetch approved/active route for delivery agent
export const getActiveRouteSuggestion = (deliveryAgentId, status = "active") =>
  api(
    `delivery_route_list_suggestions?delivery_agent_id=${deliveryAgentId}&status=${status}`,
    "GET"
  );

export const getPendingRouteSuggestion = (deliveryAgentId, status, deliveryDate = "") =>
  api(
    `delivery_route_list_suggestions?delivery_agent_id=${deliveryAgentId}&status=${status}&date=${deliveryDate}`,
    "GET"
  );

// Approve Route Suggestion
export const approveRouteSuggestion = (suggestionId) =>
  api(`delivery_route_approve_suggestion/${suggestionId}`, "POST");

// Reject Route Suggestion
export const rejectRouteSuggestion = (suggestionId) =>
  api(`delivery_route_reject_suggestion/${suggestionId}`, "POST");

// Run Scheduled Optimization - Creates a new route suggestion based on current truck location and time
export const runScheduledOptimization = (
  deliveryAgentId,
  date = "",
  debugIncludeAllOrders = false
) =>
  api(`delivery_route_run_scheduled_optimization`, "POST", {
    delivery_agent_id: deliveryAgentId,
    ...(date ? { date } : {}),
    ...(debugIncludeAllOrders ? { debug_include_all_orders: true } : {}),
  });

// Fetch orders by delivery agent and delivery date
export const fetchOrdersByDeliveryAgent = (
  deliveryAgentId = "",
  deliveryDate = "",
  size = 10000,
  page = 0,
  sortBy = "id:desc"
) =>
  api(
    `get_orders_master?size=${size}&page=${page}&orderBy=${sortBy}&deliveryDate=${deliveryDate}&delivery_agent_id=${deliveryAgentId}&includeLastOrderStatus=true`,
    "GET"
  );

// Fetch delivered orders sequence by delivery agent and date
export const getDeliveredOrdersSequence = (
  deliveryAgentId,
  deliveryDate
) =>
  api(
    `get_delivered_orders_sequence?delivery_agent_id=${deliveryAgentId}&delivery_date=${deliveryDate}`,
    "GET"
  );

// Deposit points
export const getDepositPoints = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_delivery_deposit_points?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createDepositPoint = (data) =>
  api(`add_delivery_deposit_points`, "POST", data);
export const updateDepositPoint = (id, data) =>
  api(`update_delivery_deposit_points/${id}`, "PATCH", data);
export const deleteDepositPoint = (id) =>
  api(`delete_delivery_deposit_points/${id}`, "DELETE");
export const mergeDepositPoints = (data) =>
  api(`merge_delivery_deposit_points`, "POST", data);

// cash received history
export const geCashReceivedHistory = (data) =>
  api(`get_cash_deposit_history`, "POST", data);

// warehouse
export const uploadWarehouseInvoicing = (data) =>
  multipartApi(`upload_invoice_image`, "POST", data);
export const addInvoicingRecords = (data) =>
  api(`add_warehouse_invoicing`, "POST", data);
export const updateInvoicingRecords = (id, data) =>
  api(`update_warehouse_invoicing/${id}`, "PATCH", data);
export const addWarehouseCreditNotesRecords = (data) =>
  api(`add_warehouse_credit_notes`, "POST", data);
export const getUploadedWarehouseInvoicing = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_uploaded_warehouse_invoicing?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const fetchInvoicesFromSII = (data) =>
  api(`external_invoices/fetch`, "POST", data);
export const generateAutomaticPO = () =>
  api(`automatic_po/generate`, "POST");
export const getUploadedWarehouseCreditNotes = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `get_uploaded_warehouse_credit_notes?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const generateWareHouseStockMovement = (data) =>
  api(`generate_stock_movement_report`, "POST", data);
export const generateCurrentStockReport = (data) =>
  api(`generate_current_stock_report`, "POST", data);
export const generateSecurityStockReport = (data, requestConfig = {}) =>
  api(`generate_security_stock_report`, "POST", data, requestConfig);
export const generatePosSecurityStockReport = (
  data,
  requestConfig = {}
) =>
  api(`admin/pos_security_stock_report`,
    "POST",
    data,
    requestConfig
  );
export const generateValorizedInventoryReport = (data) =>
  api(`generate_valorized_inventory_report`, "POST", data);
export const generatePriceCatalogue = (data) =>
  api(`generate_price_catalogue`, "POST", data);
export const createShrinkage = (data) =>
  api(`create_shrinkage`, "POST", data);
export const fetchWareHouseMovement = (data) =>
  api(`fetch_warehouse_movements?size=${15000}`, "POST", data);
export const generateWarehouseMovementReport = (data) =>
  api(`generate_warehouse_movement_report`, "POST", data);
export const generateStockAdjustmentReport = (data) =>
  api(`generate_stock_adjustment_report`, "POST", data);
// Perishable report — purchased/sold/shrinkage/waste kg + true margin per
// product. export_format=xlsx returns data.export.download_url (1h expiry).
export const getPerishableReport = ({
  startDate = "",
  endDate = "",
  warehouseId = "",
  producerId = "",
  exportFormat = "",
} = {}) => {
  const params = new URLSearchParams();
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  if (warehouseId && warehouseId !== "0")
    params.append("warehouse_id", warehouseId);
  if (producerId && producerId !== "0")
    params.append("producer_id", producerId);
  if (exportFormat) params.append("export_format", exportFormat);
  return api(`reports/perishable?${params.toString()}`, "GET");
};
// Perishable movement ledger (kardex) — per-product chronological physical movements with
// running balance. export_format=xlsx returns data.download_url (1h expiry).
export const getPerishableLedger = ({
  startDate = "",
  endDate = "",
  warehouseId = "",
  producerId = "",
  productMainId = "",
  exportFormat = "",
} = {}) => {
  const params = new URLSearchParams();
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  if (warehouseId && warehouseId !== "0")
    params.append("warehouse_id", warehouseId);
  if (producerId && producerId !== "0")
    params.append("producer_id", producerId);
  if (productMainId) params.append("product_main_id", productMainId);
  if (exportFormat) params.append("export_format", exportFormat);
  return api(`reports/perishable_ledger?${params.toString()}`, "GET");
};
export const generateDailyInventoryReport = (
  reportDate = "",
  warehouseId = "",
  exportFormat = "pdf",
  producerId = "",
  productMainId = "",
) => {
  let endpoint = `inventory_count/daily-report`;
  const queryParts = [];

  if (reportDate) queryParts.push(`report_date=${reportDate}`);
  if (warehouseId) queryParts.push(`warehouse_id=${warehouseId}`);
  if (exportFormat) queryParts.push(`export_format=${exportFormat}`);
  if (producerId) queryParts.push(`producer_id=${producerId}`);
  if (productMainId) queryParts.push(`product_main_id=${productMainId}`);

  if (queryParts.length > 0) {
    endpoint += `?${queryParts.join("&")}`;
  }

  return api(endpoint, "GET");
};
export const uploadCreditNotes = (data) =>
  api(`upload_credit_note_image`, "POST", data);

// guiadedispacho
export const getUploadedGuiaDeDispacho = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `warehouse/guia_despachos?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const uploadGuiaDeDispacho = (data) =>
  api(`upload_guia_despacho_image`, "POST", data);
export const addGuiaDeDispacho = (data) =>
  api(`warehouse/guia_despacho`, "POST", data);
export const getGuiaDeDispachoById = (data) =>
  api(`warehouse/guia_despacho/${data}`, "GET");
export const updateGuiaDeDispacho = (data, id) =>
  api(`warehouse/guia_despacho/${id}`, "PUT", data);
export const cancelGuiaDeDispacho = (id) =>
  api(`warehouse/guia_despacho/${id}/cancel`, "POST");

// assign daily customer
export const addSalesAgentAssignment = (data) =>
  api(`add_sales_agent_assignment`, "POST", data);
export const getSalesAgentAssignment = (
  size = 10,
  page = 0,
  selectedAssignDate = "",
  selectedSalesAgent = 0,
  sortBy = "id:desc"
) =>
  api(
    `get_sales_agent_assignments?size=${size}&page=${page}&assignment_date=${selectedAssignDate}&name=${selectedSalesAgent}&orderBy=${sortBy}`,
    "GET"
  );

//compare product
export const getCompareProduct = (id) =>
  api(`get_product_compare_list?product_master_id=${id}`, "GET");
export const updateCompareProduct = (id, data) =>
  api(`update_product_compare/${id}`, "POST", data);

//performa invoice
export const addProformaInvoice = (data) =>
  api(`add_proforma_invoicing`, "POST", data);
export const getProformaInvoice = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc",
  includeDeleted = false,
  status = ""
) => {
  let url = `get_uploaded_proforma_invoicing?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}&includeDeleted=${includeDeleted}`;
  if (status && status !== "") {
    url += `&po_status=${status}`;
  }
  return api(url, "GET");
};
export const getProformaInvoiceDetail = (data) =>
  api(`get_proforma_invoicing_by_invoice/${data}`, "GET");
export const getWareHouseInvoicingDetail = (data, size = 10000) =>
  api(`get_warehouse_invoicing_by_invoice/${data}?size=${size}`, "GET");
export const editProformaInvoiceDetail = (data) =>
  api(`update_proforma_invoicing`, "POST", data);
export const getNextPONumbar = () => api(`get_next_po_number`, "GET");
export const deletePONumbar = (id) =>
  api(`cancel_proforma_invoicing/${id}`, "DELETE");
export const approvePO = (id) =>
  api(`automatic_po/approve_po/${id}`, "PUT");
export const rejectPO = (id, data) =>
  api(`automatic_po/reject_po/${id}`, "PUT", data);
export const getOldPendingPOs = () =>
  api(`list_old_pending_pos`, "GET");
export const previewAutoSyncStockIssues = () =>
  api(`preview_auto_sync_stock_issues`, "GET");
// POs for the warehouse document-status view. `poStatus` accepts a single status or
// a comma-separated list (e.g. "issued,partially_received"); empty = all statuses.
// Optional date ranges: availability (from/to) and delivery (deliveryFrom/deliveryTo).
// Each row carries doc-status flags + presigned URLs (po_document_url, invoice_document_urls).
export const getPoDocuments = (size = 10, page = 0, filters = {}) => {
  const { poStatus, fromDate, toDate, deliveryFromDate, deliveryToDate } = filters;
  let url = `automatic_po/draft_pos?limit=${size}&page=${page}`;
  if (poStatus) url += `&po_status=${poStatus}`;
  if (fromDate) url += `&from_date=${fromDate}`;
  if (toDate) url += `&to_date=${toDate}`;
  if (deliveryFromDate) url += `&delivery_from_date=${deliveryFromDate}`;
  if (deliveryToDate) url += `&delivery_to_date=${deliveryToDate}`;
  return api(url, "GET");
};
// Upload a printed/scanned PO / supplier-invoice / credit-note document linked to a PO.
// `data` is a FormData with: file, po_number, doc_type, [supplier_invoice_number], [credit_note_number].
export const uploadPoDocument = (data) =>
  multipartApi(`po_documents/upload`, "POST", data);

// place order
export const getCategoryProductList = (data) =>
  api(`Category_Productlist`, "POST", data);
export const placeOrder = (data) => api(`admin_place_order`, "POST", data);

// coupon validation APIs
export const validateCoupon = (data) => api(`validate_coupon`, "POST", data);
export const getCouponByCode = (code) =>
  api(`get_coupon_by_code?code=${code}`, "GET");
export const getAvailableCoupons = (page = 1, limit = 50, is_active = true) =>
  api(
    `get_coupon_codes?is_active=${is_active}&page=${page}&limit=${limit}`,
    "GET"
  );

// Enhanced coupon APIs
export const getPublicCoupons = (data) =>
  api(`get_public_coupons`, "POST", data);

export const getProductsWithOffers = (region_id, name = "") =>
  api(
    `get_products_with_offers?region_id=${region_id}&name=${encodeURIComponent(name)}`,
    "GET"
  );
export const getMinTaxRate = () => api(`Min_tax_rate`, "GET");

// warehouse-manager
export const loginWareHouseManager = (data) =>
  api(`warehouse_manager/login`, "POST", data);
export const createWareHouseManager = (data) =>
  api(`warehouse_manager`, "POST", data);
export const getWareHouseManager = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `warehouse_manager?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const updateWareHouseManager = (data, id) =>
  api(`warehouse_manager/${id}`, "PATCH", data);
export const deleteWareHouseManager = (id) =>
  api(`warehouse_manager/${id}`, "DELETE");

// fidelity-user
export const getWeekDeliveriesAndFidelityStatus = (id) =>
  api(`weekly_deliveries/${id}`, "GET");

export const getUserFidelityDiscounts = (id) =>
  api(`user_fidelity_discounts/${id}`, "GET");

// margins
export const getMarginData = (startDate, endDate, sortBy = "") =>
  api(
    `get_margin_report?start_date=${startDate}&end_date=${endDate}&orderBy=${sortBy}`,
    "GET"
  );

// internal invoice
export const submitInternalInvoiceDetails = (data) =>
  multipartApi(`internal_invoice_details`, "POST", data);
export const getInternalInvoiceDetails = (id) =>
  api(`internal_invoice_details/${id}`, "GET");

// Return Request APIs
export const getReturnRequests = (
  size = 10,
  page = 0,
  status = "",
  start_date = "",
  end_date = "",
  search = ""
) =>
  api(
    `admin/return_requests?size=${size}&page=${page}&status=${status}&start_date=${start_date}&end_date=${end_date}&search=${encodeURIComponent(search)}`,
    "GET"
  );
export const getUserApprovedReturnRequests = (data) =>
  api(`get_user_approved_return_requests`, "POST", data);
export const getReturnRequestById = (id) => api(`return_requests/${id}`, "GET");
export const mergeReturnRequestInvoicePdf = (id, data) =>
  api(`return_requests/${id}/merge_invoice_pdf`, "POST", data);
export const getReturnRequestImagesBase64 = (data) =>
  api(`return_requests/images_base64`, "POST", data);
export const processReturnRequest = (data) =>
  api(`admin/return_requests/process`, "POST", data);
export const updateReturnRequest = (id, data) =>
  api(`return_requests/${id}`, "PUT", data);

// purchase patterns
export const getPurchasePatternsChartData = () =>
  api("purchase_patterns/chart");
export const getMissedPurchases = () =>
  api("purchase_patterns/missed_purchases");

// customer interviews
export const getInterviews = (
  size = 10,
  page = 0,
  name = "",
  sortBy = "id:desc"
) =>
  api(
    `colleague_interviews?size=${size}&page=${page}&name=${name}&orderBy=${sortBy}`,
    "GET"
  );
export const createInterview = (data) =>
  multipartApi(`colleague_interviews`, "POST", data);
export const updateInterview = (id, data) =>
  multipartApi(`colleague_interviews/${id}`, "PUT", data);
export const deleteInterview = (id) =>
  api(`colleague_interviews/${id}`, "DELETE");
export const getInterview = (id) => api(`colleague_interviews/${id}`, "GET");

// Sales Whatsapp APIs
export const getSalesChats = (query = "") =>
  api(`whatsapp/sales_chats${query}`, "GET");
export const sendSalesMessage = (data) =>
  api(`whatsapp/sales_user/send`, "POST", data);
export const sendSalesTemplate = (data) =>
  api(`whatsapp/sales_user/send_template`, "POST", data);

// customer purchase patterns
export const getCustomerPurchasePatterns = (data) =>
  api(`customer_purchase_history`, "POST", data);

// Pending POS products (product_master.request_status = 'pending')
export const getPendingProducts = (
  size = 10,
  page = 0,
  name = "",
  requestedBy = ""
) =>
  api(
    `get_pending_requests?size=${size}&page=${page}&name=${name}${
      requestedBy ? `&requested_by=${requestedBy}` : ""
    }`,
    "GET"
  );
export const reviewPendingProducts = (data) =>
  api(`review_pending_products`, "PATCH", data);

export const getAdminPosSales = (params = {}) => {
  const q = new URLSearchParams();
  q.append("size", String(params.size ?? 10));
  q.append("page", String(params.page ?? 0));
  q.append("orderBy", params.orderBy || "id:desc");
  if (params.name) q.append("name", params.name);
  if (params.sales_type) q.append("sales_type", params.sales_type);
  if (params.user_id) q.append("user_id", String(params.user_id));
  if (params.start_date) q.append("start_date", params.start_date);
  if (params.end_date) q.append("end_date", params.end_date);
  if (params.has_s22) q.append("has_s22", params.has_s22);
  return api(`get_pos_sales?${q.toString()}`, "GET");
};

export const getPosSaleById = (id) => api(`get_pos_sales_by_id/${id}`, "GET");

// Document generation APIs using invoiceApi (DTE v2.0 endpoints with /api prefix)
export const generateDocumentInvoice = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "factura",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateDocumentBoleta = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "boleta",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateDocumentDispatchGuide = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "guia-despacho/electronica",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateDocumentManualDispatchGuide = (data) =>
  invoiceApi("guia-despacho/manual", "POST", data);
export const generateDocumentTotalCreditNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-credito/total",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateDocumentPartialCreditNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-credito/parcial",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateDocumentProductDebitNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-debito/productos",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateDocumentAmountDebitNote = (data, orderDocument) =>
  api("admin/sii/proxy_emission", "POST", {
    endpoint: "nota-debito/monto",
    payload: data,
    ...(orderDocument ? { order_document: orderDocument } : {}),
  });
export const generateDocumentRawDebitNote = (data) =>
  invoiceApi("nota-debito/generar-y-enviar", "POST", data);

// DTE v2.0 - Status Queries (no /api prefix per manual)
export const checkDteSubmissionStatus = (data) =>
  invoiceApi("consulta/envio", "POST", data);
export const checkDteStatus = (data) =>
  invoiceApi("consulta/estado", "POST", data);
export const checkDteFullStatus = (data) =>
  invoiceApi("estado-completo", "POST", data);

// DTE v2.0 - CAF & Queue Management (no /api prefix per manual)
export const uploadCafXml = (data) =>
  invoiceApi("caf/upload", "POST", data);
export const retryDteManually = (data) =>
  invoiceApi("reenviar", "POST", data);
export const triggerDteQueueProcessing = (data) =>
  invoiceApi("cron/procesar-cola", "POST", data);

// Document management APIs
export const fetchDocuments = async (
  page = 1,
  limit = 10,
  type = "all",
  startDate = "",
  endDate = "",
  extraFilters = {}
) => {
  // extraFilters: { user_id, address_id, sii_company_id, estado, source } —
  // unified ledger filters (store-emitted DTEs share the documents table)
  let url = `documents?page=${page}&size=${limit}&type=${type}&start_date=${startDate}&end_date=${endDate}`;
  const { user_id, address_id, sii_company_id, estado, source } = extraFilters || {};
  if (user_id) url += `&user_id=${user_id}`;
  if (address_id) url += `&address_id=${address_id}`;
  if (sii_company_id) url += `&sii_company_id=${sii_company_id}`;
  if (estado) url += `&estado=${estado}`;
  if (source && source !== "all") url += `&source=${source}`;
  return api(url, "GET");
};
export const createDocument = async (documentData) => {
  return api("documents", "POST", documentData);
};

// Holiday APIs
export const fetchHolidays = (
  size = 10,
  page = 1,
  orderBy = "holiday_date:asc",
  holiday_name = "",
  holiday_type = "",
  location_id = "",
  region_id = "",
  from_date = "",
  to_date = ""
) => {
  let query = `get_holidays?page=${page}&size=${size}&orderBy=${orderBy}`;
  if (holiday_name) query += `&holiday_name=${holiday_name}`;
  if (holiday_type) query += `&holiday_type=${holiday_type}`;
  if (location_id) query += `&location_id=${location_id}`;
  if (region_id) query += `&region_id=${region_id}`;
  if (from_date) query += `&from_date=${from_date}`;
  if (to_date) query += `&to_date=${to_date}`;
  return api(query, "GET");
};

export const addHoliday = (data) => api("add_holiday", "POST", data);

export const updateHoliday = (data, id) =>
  api(`update_holiday/${id}`, "PATCH", data);

export const getHolidayById = (id) => api(`get_holiday_by_id/${id}`, "GET");

export const getHolidaysByDateRange = (
  from_date,
  to_date,
  location_id = ""
) => {
  let query = `get_holidays_by_date_range?from_date=${from_date}&to_date=${to_date}`;
  if (location_id) query += `&location_id=${location_id}`;
  return api(query, "GET");
};

export const deleteHoliday = (id) => api(`delete_holiday/${id}`, "DELETE");

// FAQ APIs
export const fetchFAQs = (
  size = 10,
  page = 0,
  orderBy = "sort_order:asc",
  search = "",
  is_active = ""
) => {
  let query = `get_faqs?page=${page}&size=${size}&orderBy=${orderBy}`;
  if (search) query += `&search=${search}`;
  if (is_active !== "") query += `&is_active=${is_active}`;
  return api(query, "GET");
};

export const addFAQ = (data) => api("add_faq", "POST", data);

export const updateFAQ = (data, id) => api(`update_faq/${id}`, "PATCH", data);

export const getFAQById = (id) => api(`get_faq_by_id/${id}`, "GET");

export const toggleFAQStatus = (id) =>
  api(`toggle_faq_status/${id}`, "PATCH");

export const deleteFAQ = (id) => api(`delete_faq/${id}`, "DELETE");

export const downloadAllDocument = async (
  type = "all",
  startDate = "",
  endDate = "",
  deliveryAgentId = ""
) => {
  const deliveryAgentParam = deliveryAgentId
    ? `&delivery_agent_id=${deliveryAgentId}`
    : "";
  return api(
    `documents/download?type=${type}&start_date=${startDate}&end_date=${endDate}${deliveryAgentParam}`,
    "GET"
  );
};

export const updateDocument = async (id, documentData) => {
  return api(`documents/${id}`, "PUT", documentData);
};

export const deleteDocument = async (id) => {
  return api(`documents/${id}`, "DELETE");
};

export const downloadDocument = async (documentId) => {
  return api(`documents/${documentId}/download`, "GET");
};

export const getDocumentHistory = async (documentId) => {
  return api(`documents/${documentId}/history`, "GET");
};

// SII sync APIs
export const syncInvoiceWithSII = (rut) =>
  invoiceApi("buscar", "POST", { rut });

// Customer APIs
export const createCustomer = (data) => api(`create_customer`, "POST", data);

// Order Reminders APIs
export const syncOrderReminders = (data) =>
  api(`order_reminders/sync`, "POST", data);

export const getReminderCandidates = (
  daysBack = 14,
  minOrderValue = 5000,
  regions = "",
  limit = 50,
  reminderFrequencyDays = 14
) =>
  api(
    `order_reminders/candidates?daysBack=${daysBack}&minOrderValue=${minOrderValue}&regions=${regions}&limit=${limit}&reminderFrequencyDays=${reminderFrequencyDays}`,
    "GET"
  );

export const sendManualReminders = (data) =>
  api(`order_reminders/send`, "POST", data);

export const getReminderAnalytics = (
  startDate = "",
  endDate = "",
  userId = ""
) =>
  api(
    `order_reminders/analytics?startDate=${startDate}&endDate=${endDate}&userId=${userId}`,
    "GET"
  );

export const triggerInvoiceBatch = (data) =>
  api("trigger_invoice_batch", "POST", data);

// OCR Records APIs - POS Bulk OCR Invoice
export const getOcrRecords = (filters = {}) => {
  const queryParams = new URLSearchParams();

  // Pagination: backend getPagination uses query `size` and `page` as 0-based index (offset = page * limit)
  if (filters.page != null && filters.page !== "") {
    const apiPage = Math.max(0, Number(filters.page) - 1);
    queryParams.append("page", String(apiPage));
  }
  if (filters.limit != null && filters.limit !== "") {
    queryParams.append("size", String(filters.limit));
  }

  // Filters
  if (filters.status && filters.status !== "all") {
    queryParams.append("status", filters.status);
  }
  if (filters.user_id) {
    queryParams.append("user_id", filters.user_id);
  }
  if (filters.start_date) {
    queryParams.append("start_date", filters.start_date);
  }
  if (filters.end_date) {
    queryParams.append("end_date", filters.end_date);
  }
  if (filters.batch_id) {
    queryParams.append("batch_id", filters.batch_id);
  }
  if (filters.invoice_number_pattern) {
    queryParams.append(
      "invoice_number_pattern",
      filters.invoice_number_pattern
    );
  }
  if (filters.supplier_name) {
    queryParams.append("supplier_name", filters.supplier_name);
  }
  if (filters.min_file_size) {
    queryParams.append("min_file_size", filters.min_file_size);
  }
  if (filters.max_file_size) {
    queryParams.append("max_file_size", filters.max_file_size);
  }

  const query = queryParams.toString();
  return api(
    `pos_bulk_ocr_invoice/admin/records${query ? `?${query}` : ""}`,
    "GET"
  );
};

export const getOcrRecord = (id) =>
  api(`pos_bulk_ocr_invoice/admin/record/${id}`, "GET");

// FE passes the line_index -> product_master_id map it already has from the
// review modal's AsyncSelect — saves the BE from doing fuzzy lookups per line.
export const getOcrInventoryPreview = (id, payload) =>
  api(
    `pos_bulk_ocr_invoice/admin/record/${id}/inventory_preview`,
    "POST",
    payload || { items: [] }
  );

export const updateOcrRecord = (id, data) =>
  api(`pos_bulk_ocr_invoice/admin/record/${id}`, "PUT", data);

export const processInventory = (data) =>
  api("pos_bulk_ocr_invoice/admin/process_inventory", "POST", data);

export const bulkStatusUpdate = (data) =>
  api("pos_bulk_ocr_invoice/admin/bulk_status_update", "PUT", data);

export const exportOcrRecords = (filters = {}, format = "csv") => {
  const queryParams = new URLSearchParams();

  // Add all filters
  Object.keys(filters).forEach((key) => {
    if (filters[key] && filters[key] !== "all") {
      queryParams.append(key, filters[key]);
    }
  });

  queryParams.append("format", format);
  return api(`pos_bulk_ocr_invoice/admin/export?${queryParams}`, "GET");
};

// Admin Upload APIs - POS Bulk OCR Invoice
export const getUsers = (searchTerm = "") => {
  const query = searchTerm ? `?search=${searchTerm}` : "";
  return api(`users${query}`, "GET");
};

export const uploadFilesForUser = (userId, files, uploadData) => {
  const formData = new FormData();
  formData.append("user_id", userId);
  formData.append("notes", uploadData.notes || "");
  formData.append("priority", uploadData.priority || "normal");

  // Append each file
  files.forEach((file, index) => {
    formData.append("files", file);
  });

  return multipartApi(
    "pos_bulk_ocr_invoice/admin/upload_for_user",
    "POST",
    formData
  );
};

export const getUploadHistory = (filters = {}) => {
  const queryParams = new URLSearchParams();

  // Pagination
  if (filters.page) queryParams.append("page", filters.page);
  if (filters.limit) queryParams.append("limit", filters.limit);

  // Filters
  if (filters.user_id) {
    queryParams.append("user_id", filters.user_id);
  }
  if (filters.start_date) {
    queryParams.append("start_date", filters.start_date);
  }
  if (filters.end_date) {
    queryParams.append("end_date", filters.end_date);
  }

  const query = queryParams.toString();
  return api(
    `pos_bulk_ocr_invoice/admin/upload_history${query ? `?${query}` : ""}`,
    "GET"
  );
};

export const getUploadStatus = (batchId) =>
  api(`pos_bulk_ocr_invoice/admin/upload_status/${batchId}`, "GET");

// Invoice API Usage Dashboard APIs
export const getInvoiceDashboardOverall = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.environment) queryParams.append("environment", params.environment);

  const query = queryParams.toString();
  return invoiceApi(`dashboard/overall${query ? `?${query}` : ""}`, "GET");
};

export const getInvoiceDashboardSummary = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.environment) queryParams.append("environment", params.environment);

  const query = queryParams.toString();
  return invoiceApi(`dashboard/summary${query ? `?${query}` : ""}`, "GET");
};

export const getInvoiceDashboardLogs = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.apiName) queryParams.append("apiName", params.apiName);
  if (params.status) queryParams.append("status", params.status);
  if (params.documentType)
    queryParams.append("documentType", params.documentType);
  if (params.rutEmisor) queryParams.append("rutEmisor", params.rutEmisor);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  const query = queryParams.toString();
  return invoiceApi(`dashboard/logs${query ? `?${query}` : ""}`, "GET");
};

export const getInvoiceDashboardUsageByTime = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.groupBy) queryParams.append("groupBy", params.groupBy);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.environment) queryParams.append("environment", params.environment);

  const query = queryParams.toString();
  return invoiceApi(
    `dashboard/usage-by-time${query ? `?${query}` : ""}`,
    "GET"
  );
};

export const getInvoiceDashboardDocumentTypes = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.environment) queryParams.append("environment", params.environment);

  const query = queryParams.toString();
  return invoiceApi(
    `dashboard/document-types${query ? `?${query}` : ""}`,
    "GET"
  );
};

export const getInvoiceDashboardRutStats = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.limit) queryParams.append("limit", params.limit);

  const query = queryParams.toString();
  return invoiceApi(`dashboard/rut-stats${query ? `?${query}` : ""}`, "GET");
};

export const getInvoiceDashboardErrors = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.apiName) queryParams.append("apiName", params.apiName);
  if (params.environment) queryParams.append("environment", params.environment);

  const query = queryParams.toString();
  return invoiceApi(`dashboard/errors${query ? `?${query}` : ""}`, "GET");
};

export const getInvoiceDashboardCosts = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.environment) queryParams.append("environment", params.environment);
  if (params.groupBy) queryParams.append("groupBy", params.groupBy);

  const query = queryParams.toString();
  return invoiceApi(`dashboard/costs${query ? `?${query}` : ""}`, "GET");
};

export const getInvoiceDashboardHealth = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.environment) queryParams.append("environment", params.environment);

  const query = queryParams.toString();
  return invoiceApi(`dashboard/health${query ? `?${query}` : ""}`, "GET");
};

export const getInvoiceDashboard = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.groupBy) queryParams.append("groupBy", params.groupBy);
  if (params.environment) queryParams.append("environment", params.environment);

  const query = queryParams.toString();
  return invoiceApi(`dashboard${query ? `?${query}` : ""}`, "GET");
};

// Activity Logs APIs
export const getActivityLogs = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search) queryParams.append("search", params.search);
  if (params.user_id) queryParams.append("user_id", params.user_id);
  if (params.user_email) queryParams.append("user_email", params.user_email);
  if (params.user_role) queryParams.append("user_role", params.user_role);
  if (params.activity_type)
    queryParams.append("activity_type", params.activity_type);
  if (params.method) queryParams.append("method", params.method);
  if (params.response_status)
    queryParams.append("response_status", params.response_status);
  if (params.success !== undefined && params.success !== "")
    queryParams.append("success", params.success);
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);
  if (params.ip_address) queryParams.append("ip_address", params.ip_address);
  if (params.sort_by) queryParams.append("sort_by", params.sort_by);
  if (params.sort_order) queryParams.append("sort_order", params.sort_order);

  const query = queryParams.toString();
  return api(`activity_logs${query ? `?${query}` : ""}`, "GET");
};

export const getActivityLogById = (id) => {
  return api(`activity_logs/${id}`, "GET");
};

export const getPasswordResetFlow = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.email) queryParams.append("email", params.email);
  if (params.user_id) queryParams.append("user_id", params.user_id);
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);

  const query = queryParams.toString();
  return api(
    `activity_logs/flow/password_reset${query ? `?${query}` : ""}`,
    "GET"
  );
};

export const getActivityAnalytics = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);
  if (params.group_by) queryParams.append("group_by", params.group_by);

  const query = queryParams.toString();
  return api(`activity_logs/analytics/stats${query ? `?${query}` : ""}`, "GET");
};

export const getUserActivityTimeline = (userId, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);

  const query = queryParams.toString();
  return api(
    `activity_logs/user/${userId}/timeline${query ? `?${query}` : ""}`,
    "GET"
  );
};

export const cleanupActivityLogs = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.days_old) queryParams.append("days_old", params.days_old);

  const query = queryParams.toString();
  return api(`activity_logs/cleanup${query ? `?${query}` : ""}`, "DELETE");
};

// Clara AI Chatbot APIs
export const startClaraConversation = (data) =>
  api("clara/conversation/start", "POST", data);

export const sendClaraMessage = (data) => api("clara/chat", "POST", data);

export const sendClaraAuthMessage = (data) =>
  api("clara/auth/chat", "POST", data);

export const getClaraConversation = (sessionId) =>
  api(`clara/conversation/${sessionId}`, "GET");

export const endClaraConversation = (sessionId) =>
  api(`clara/conversation/${sessionId}/end`, "POST");

export const getClaraUserConversations = () => api("clara/conversations", "GET");

export const deleteClaraConversation = (sessionId) =>
  api(`clara/conversation/${sessionId}`, "DELETE");

export const searchClaraProducts = (query) =>
  api(`clara/products/search?q=${query}`, "GET");

export const getClaraOffers = () => api("clara/offers", "GET");

// Clara Admin APIs
export const getClaraAdminConversations = () =>
  api("clara/admin/conversations", "GET");

export const getClaraAdminAnalytics = () => api("clara/admin/analytics", "GET");

// Delivery Charges Configuration APIs
export const getDeliveryChargesConfigs = (params = {}) => {
  const queryParams = new URLSearchParams();
  // Ensure page is always a valid number, default to 0
  const page = params.page !== undefined && params.page !== null && !isNaN(Number(params.page))
    ? Number(params.page)
    : 0;
  queryParams.append("page", page);

  if (params.size) queryParams.append("size", params.size);
  if (params.region_id) queryParams.append("region_id", params.region_id);
  if (params.is_active !== undefined)
    queryParams.append("is_active", params.is_active);
  const query = queryParams.toString();
  return api(`delivery_charges_config${query ? `?${query}` : ""}`, "GET");
};

export const getDeliveryChargesConfigById = (id) =>
  api(`delivery_charges_config/${id}`, "GET");

export const createDeliveryChargesConfig = (data) =>
  api("delivery_charges_config", "POST", data);

export const updateDeliveryChargesConfig = (id, data) =>
  api(`delivery_charges_config/${id}`, "PUT", data);

export const deleteDeliveryChargesConfig = (id) =>
  api(`delivery_charges_config/${id}`, "DELETE");

export const getDeliveryChargesConfigByRegion = (regionId) =>
  api(`delivery_charges_config/region/${regionId}`, "GET");

export const getActiveDeliveryChargesConfig = (regionId) =>
  api(`delivery_charges_config/active/${regionId}`, "GET");

// Gift APIs
export const fetchGifts = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search) queryParams.append("search", params.search);
  if (params.is_active !== undefined)
    queryParams.append("is_active", params.is_active);
  if (params.region_id) queryParams.append("region_id", params.region_id);
  if (params.sort_by) queryParams.append("sort_by", params.sort_by);
  if (params.sort_order) queryParams.append("sort_order", params.sort_order);
  const query = queryParams.toString();
  return api(`gifts${query ? `?${query}` : ""}`, "GET");
};

export const fetchGiftById = (id) => api(`gifts/${id}`, "GET");

export const fetchDefaultGift = () => api(`gifts/default`, "GET");

export const createGift = (data) => api(`gifts`, "POST", data);

export const updateGift = (id, data) => api(`gifts/${id}`, "PUT", data);

export const deleteGift = (id) => api(`gifts/${id}`, "DELETE");

export const updateGiftStock = (id, data) =>
  api(`gifts/${id}/stock`, "PATCH", data);

export const fetchGiftStatistics = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);
  const query = queryParams.toString();
  return api(`gifts/statistics${query ? `?${query}` : ""}`, "GET");
};

// Customer Gift APIs
export const sendGiftToCustomer = (data) => api(`gifts/send`, "POST", data);

export const fetchCustomerGifts = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.user_id) queryParams.append("user_id", params.user_id);
  if (params.status) queryParams.append("status", params.status);
  if (params.order_id) queryParams.append("order_id", params.order_id);
  if (params.sort_by) queryParams.append("sort_by", params.sort_by);
  if (params.sort_order) queryParams.append("sort_order", params.sort_order);
  const query = queryParams.toString();
  return api(`gifts/customer${query ? `?${query}` : ""}`, "GET");
};

export const fetchPendingGiftsForUser = (userId) =>
  api(`gifts/customer/pending/${userId}`, "GET");

export const fetchCustomerGiftById = (id) => api(`gifts/customer/${id}`, "GET");

export const cancelCustomerGift = (id, data) =>
  api(`gifts/customer/${id}/cancel`, "POST", data);

// Delivery Satisfaction Report
export const getDeliverySatisfactionReport = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page !== undefined) queryParams.append("page", params.page);
  if (params.size) queryParams.append("size", params.size);
  if (params.start_date) queryParams.append("start_date", params.start_date);
  if (params.end_date) queryParams.append("end_date", params.end_date);
  if (params.delivery_agent_id)
    queryParams.append("delivery_agent_id", params.delivery_agent_id);
  if (params.location_id) queryParams.append("location_id", params.location_id);
  if (params.rating) queryParams.append("rating", params.rating);
  if (params.name) queryParams.append("search", params.name);

  const query = queryParams.toString();
  return api(`delivery_satisfaction_report${query ? `?${query}` : ""}`, "GET");
};

// Admin — online consumers & stores (admin-only API)
export const getAdminOnlineStores = (params = {}) => {
  const q = new URLSearchParams();
  if (params.page !== undefined && params.page !== null) q.append("page", String(params.page));
  if (params.size !== undefined && params.size !== null) q.append("size", String(params.size));
  if (params.search) q.append("search", params.search);
  if (params.is_pos_active !== undefined && params.is_pos_active !== null && params.is_pos_active !== "") {
    q.append("is_pos_active", String(params.is_pos_active));
  }
  const qs = q.toString();
  return api(`admin/online/stores${qs ? `?${qs}` : ""}`, "GET");
};

export const getAdminOnlineStoreById = (id) =>
  api(`admin/online/stores/${id}`, "GET");

// Admin — POS auto-PO recommendations for a specific store (by store owner user_id)
export const getPosStoreRecommendations = (params = {}) => {
  const q = new URLSearchParams();
  if (params.store_id !== undefined && params.store_id !== null && params.store_id !== "")
    q.append("store_id", String(params.store_id));
  if (params.page !== undefined && params.page !== null) q.append("page", String(params.page));
  if (params.size !== undefined && params.size !== null) q.append("size", String(params.size));
  if (params.search) q.append("search", params.search);
  if (params.status) q.append("status", params.status);
  if (params.include_removed) q.append("include_removed", String(params.include_removed));
  const qs = q.toString();
  return api(`pos_auto_po/admin/recommendations${qs ? `?${qs}` : ""}`, "GET");
};

// Admin — "Recompute now" for a single store. Synchronous per-store recompute so the
// admin sees fresh numbers immediately (the cron/drain job handles the rest in the background).
export const recomputePosStoreRecommendations = (storeId) =>
  api(`pos_auto_po/admin/recommendations/recompute`, "POST", { store_id: storeId });

// POS Analytics dashboard (admin) — see backend app/controllers/pos_analytics.controller.js.
// `resource` is the endpoint slug (overview, sales_trend, top_products, …); params are
// the shared filter set (start_date, end_date, store_id, producer_id, product_type, …).
export const getPosAnalytics = (resource, params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") q.append(key, String(value));
  });
  const qs = q.toString();
  return api(`pos_analytics/${resource}${qs ? `?${qs}` : ""}`, "GET");
};

export const updateAdminOnlineStore = (id, data) =>
  api(`admin/online/stores/${id}`, "PATCH", data);

export const updateAdminOnlineStoreUser = (userId, data) =>
  api(`admin/online/store_users/${userId}`, "PATCH", data);

export const getAdminOnlineConsumers = (params = {}) => {
  const q = new URLSearchParams();
  if (params.page !== undefined && params.page !== null) q.append("page", String(params.page));
  if (params.size !== undefined && params.size !== null) q.append("size", String(params.size));
  if (params.search) q.append("search", params.search);
  if (params.status) q.append("status", params.status);
  const qs = q.toString();
  return api(`admin/online/consumers${qs ? `?${qs}` : ""}`, "GET");
};

export const getAdminOnlineConsumerById = (id, params = {}) => {
  const q = new URLSearchParams();
  if (params.page !== undefined && params.page !== null) q.append("page", String(params.page));
  if (params.size !== undefined && params.size !== null) q.append("size", String(params.size));
  const qs = q.toString();
  return api(`admin/online/consumers/${id}${qs ? `?${qs}` : ""}`, "GET");
};

export const getAdminOnlineOrders = (params = {}) => {
  const q = new URLSearchParams();
  if (params.page !== undefined && params.page !== null) q.append("page", String(params.page));
  if (params.size !== undefined && params.size !== null) q.append("size", String(params.size));
  if (params.search) q.append("search", params.search);
  if (params.order_status) q.append("order_status", params.order_status);
  if (params.store_user_id) q.append("store_user_id", String(params.store_user_id));
  if (params.date_from) q.append("date_from", params.date_from);
  if (params.date_to) q.append("date_to", params.date_to);
  const qs = q.toString();
  return api(`admin/online/orders${qs ? `?${qs}` : ""}`, "GET");
};

// Account / data deletion requests (consumer accounts)
export const getAccountDeletionRequests = (params = {}) => {
  const q = new URLSearchParams();
  if (params.page !== undefined && params.page !== null) q.append("page", String(params.page));
  if (params.size !== undefined && params.size !== null) q.append("size", String(params.size));
  if (params.search) q.append("search", params.search);
  if (params.status) q.append("status", params.status);
  const qs = q.toString();
  return api(`account_deletion_requests${qs ? `?${qs}` : ""}`, "GET");
};

export const getAccountDeletionRequestById = (id) =>
  api(`account_deletion_requests/${id}`, "GET");

export const processAccountDeletionRequest = (id, data = {}) =>
  api(`account_deletion_requests/${id}/process`, "POST", data);

export const cancelAccountDeletionRequest = (id, data = {}) =>
  api(`account_deletion_requests/${id}/cancel`, "POST", data);

// App Settings
export const getAppSettings = () => api("app_settings", "GET");
export const createOrUpdateAppSetting = (data) =>
  api("app_settings", "POST", data);
export const updateAppVersion = (data) => api("app_version", "PUT", data);

// Activity Logs
export const getActivityLogsChart = (startDate, endDate, groupBy = "day") => {
  const queryParams = new URLSearchParams();
  queryParams.append("start_date", startDate);
  queryParams.append("end_date", endDate);
  queryParams.append("group_by", groupBy);
  return api(`activity_logs/chart?${queryParams.toString()}`, "GET");
};

// =====================================================================
// Automations / System Jobs (manual triggers for scheduled background jobs)
// =====================================================================
//
// Notes on auth:
//   Some endpoints in this group are protected on the backend with
//   `x-api-key` or `x-sync-secret`. Per the spec, those secrets MUST NOT
//   ship in the browser bundle. The expectation is that the admin panel's
//   own backend (BFF) reads those env vars server-side and either:
//     (a) accepts the call from the authenticated admin and forwards it
//         to the upstream service with the secret attached, or
//     (b) the upstream service is configured to also accept the admin
//         JWT (`x-access-token`) for these routes.
//
//   The FE simply calls the existing `api()` helper here (which sends the
//   admin JWT). We additionally include `x-trigger-source: admin-panel` so
//   the BFF can recognize panel-originated calls.
const automationApi = (path, body) =>
  api(path, "POST", body || {}, {
    headers: { "x-trigger-source": "admin-panel" },
  });

// 3.1 Order Reminders & Lifecycle
export const automationSendDailyOrderEmailReminders = () =>
  automationApi("send_daily_order_email_reminders");
export const automationSendOrderEmailReminders = () =>
  automationApi("send_order_email_reminders");
export const automationSendDailyOrderWhatsappReminders = () =>
  automationApi("send_daily_order_whatsapp_reminders");
export const automationSendLastOrderEmailReminders = () =>
  automationApi("send_last_order_email_reminders");
export const automationSendLastOrderWhatsappReminders = () =>
  automationApi("send_last_order_whatsapp_reminders");
export const automationCancelUnresponsiveOrders = () =>
  automationApi("cancel_unresponsive_orders");

// 3.2 Purchase Orders & Stock
export const automationGenerateAutomaticPOs = () =>
  automationApi("automatic_po/generate");
export const automationUpdateStockMovements = () =>
  automationApi("update_stock_movements");
export const automationRecomputePosAutoPoAll = (force = true) =>
  automationApi("pos_auto_po/recommendations/recompute_all", { force });

// 3.3 Invoicing
export const automationTriggerInvoiceBatch = (date) =>
  automationApi("trigger_invoice_batch", { date });
export const automationGenerateInvoicesForToday = () =>
  automationApi("automatic_invoice_generation/generate_invoices_for_today");
export const automationFetchExternalInvoices = ({
  desde,
  hasta,
  warehouse_id,
}) => {
  const body = { desde, hasta };
  if (warehouse_id !== undefined && warehouse_id !== null && warehouse_id !== "") {
    body.warehouse_id = Number(warehouse_id);
  }
  return automationApi("external_invoices/fetch", body);
};

// 3.4 POS / Store Sync
export const automationSyncPosInventoryFromDeliveryFeedback = ({
  limit = 1000,
  dry_run = false,
} = {}) =>
  automationApi("sync_pos_inventory_from_delivery_feedback", {
    trigger_type: "manual",
    limit: Number(limit) || 1000,
    dry_run: !!dry_run,
  });
export const automationSyncCustomerRelease = () =>
  automationApi("sync_customer_release");

// 3.5 Delivery & Routes
export const automationDeliveryRouteRunScheduledOptimization = () =>
  automationApi("delivery_route_run_scheduled_optimization");
export const automationRefreshAllDeliveryEtas = () =>
  automationApi("refresh_all_delivery_etas");
export const automationProcessAllDeliveryEtas = () =>
  automationApi("process_all_delivery_etas");

// 3.6 Recommendations & Re-engagement (chained pipeline)
export const automationAnalyzePurchasePatterns = () =>
  automationApi("purchase_patterns/analyze");
export const automationAnalyzeMissedPurchases = () =>
  automationApi("missed_purchases/analyze");
export const automationGenerateMissedPurchaseNotifications = () =>
  automationApi("generate_missed_purchase_notifications");
export const automationGenerateSalesNotifications = () =>
  automationApi("generate_sales_notifications");
export const automationGeneratePersonalizedRecommendations = () =>
  automationApi("generate_personalized_recommendations");

// 3.7 Monitoring
export const automationCheckNegativeStockAlert = () =>
  automationApi("check_negative_stock_alert");

export const getActivityLogsList = (params = {}) => {
  const {
    page = 0,
    size = 50,
    activity_type,
    success,
    method,
    response_status,
    custom_query,
    sort_by = "created_at",
    sort_order = "DESC",
  } = params;

  // Build query params manually to avoid double encoding of custom_query
  const queryParts = [];

  if (page !== undefined && page !== null) queryParts.push(`page=${page}`);
  if (size !== undefined && size !== null) queryParts.push(`size=${size}`);
  if (activity_type) queryParts.push(`activity_type=${encodeURIComponent(activity_type)}`);
  if (success !== undefined && success !== null && success !== "") {
    const successValue = typeof success === "boolean" ? String(success) : success;
    queryParts.push(`success=${encodeURIComponent(successValue)}`);
  }
  if (method) queryParts.push(`method=${encodeURIComponent(method)}`);
  if (response_status !== undefined && response_status !== null && response_status !== "") {
    queryParts.push(`response_status=${encodeURIComponent(response_status)}`);
  }
  if (sort_by) queryParts.push(`sort_by=${encodeURIComponent(sort_by)}`);
  if (sort_order) queryParts.push(`sort_order=${encodeURIComponent(sort_order)}`);

  // Handle custom_query separately - pass it unencoded so updateURL can encode it once
  if (custom_query) {
    const queryStringValue = typeof custom_query === "string" ? custom_query : JSON.stringify(custom_query);
    // Pass unencoded - the api function's updateURL will encode it
    queryParts.push(`custom_query=${queryStringValue}`);
  }

  const queryString = queryParts.join("&");

  return api(`activity_logs/list?${queryString}`, "GET");
};
// ─── SII (DTE) — store companies (backend /admin/sii/*) ──────────────────────
// Onboarding is per delivery address (each delivery address is a store).
// Document history lives in the unified GET /documents endpoint.
export const fetchSiiCompanies = (params = {}) => {
  const { page = 1, size = 10, status, search, user_id, address_id, is_platform } = params;
  let url = `admin/sii/fetch_companies?page=${page}&size=${size}`;
  if (status) url += `&status=${status}`;
  if (user_id) url += `&user_id=${user_id}`;
  if (address_id) url += `&address_id=${address_id}`;
  if (is_platform !== undefined) url += `&is_platform=${is_platform ? 1 : 0}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  return api(url, "GET");
};
export const getPlatformSiiCompany = () =>
  api(`admin/sii/platform_company`, "GET");
export const setPlatformSiiCompany = (id) =>
  api(`admin/sii/set_platform_company/${id}`, "PATCH");
// Sync & repair: reconcile the local mirror with the invoicing service
export const syncSiiCompanies = () => api(`admin/sii/sync_companies`, "POST");
export const linkSiiCompany = (data) => api(`admin/sii/link_company`, "POST", data);
export const syncSiiDocuments = () => api(`admin/sii/sync_documents`, "POST");
// Manual resend of a failed/queued DTE (same folio — never a new document)
export const retrySiiDocument = (id) => api(`admin/sii/retry_document/${id}`, "POST");
// SII queue health: { queued, failed } counts
export const getSiiPendingSummary = () => api(`admin/sii/pending_summary`, "GET");
// Manual triggers for the SII cron jobs (fallback when an EventBridge Lambda
// misses a run). Same handlers the cron hits, behind admin JWT.
export const processSiiResendQueue = () =>
  api(`admin/sii/process_resend_queue`, "POST");
export const processSiiSupplierEmails = () =>
  api(`admin/sii/process_supplier_emails`, "POST");
// "Invoice App Docs" — documents straight from the invoice-saas ledger (read-only,
// for admins double-checking what was issued on the invoice system).
export const getSaasDocuments = (filters = {}) => {
  const params = Object.entries(filters)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return api(`admin/sii/saas_documents${params ? `?${params}` : ""}`, "GET");
};
export const fetchSiiCompanyById = (id) =>
  api(`admin/sii/fetch_company/${id}`, "GET");
export const addSiiCompany = (formData) =>
  multipartApi(`admin/sii/add_company`, "POST", formData);
export const updateSiiCompany = (id, formData) =>
  multipartApi(`admin/sii/update_company/${id}`, "PUT", formData);
export const toggleSiiCompanyStatus = (id, status) =>
  api(`admin/sii/toggle_company_status/${id}`, "PATCH", { status });
export const uploadSiiCaf = (id, formData) =>
  multipartApi(`admin/sii/upload_caf/${id}`, "POST", formData);
export const emitSiiDocument = (companyId, data) =>
  api(`admin/sii/emit_document/${companyId}`, "POST", data);
